import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";

import Select from "react-select";
import CustomSelectInput from "../../../components/common/CustomSelectInput";
import {
  DateGetSalary,
  SalaryBy,
  HourWorkingOnDay,
  GetHourWorkingOnDay,
  GetStatusWorking,
  GetSalaryBy,
  GetDateGetSalary,
  StatusWorking,
  GetWorkingHours,
  PositionOptions,
  GetPosition,
} from "../../../helpers/UserStaff";
import DatePicker from "react-datepicker";
import moment from "moment";
import { AddCommaNumber } from "../../../helpers/Utils";
import ShiftSelect from "./ShiftSelect";
import DynamicForm from "../general/DynamicForm";
import TooltipItem from "../../../components/common/TooltipItem";
import PerfectScrollbar from "react-perfect-scrollbar";

const ContentComponent = ({
  title,
  isOpen,
  isLoading,
  toggle,
  onSubmit,
  data_dynamic_form,
  values,
  setting,
  onChange,
  onChangeWorkingHours,
  // onAddWorkingHours,
  // onRemoveWorkingHours,
  onChangeDynamicForm,
  salaryDownloadData,
  onClickDownloadSalary,
  // onSaveWelfare,
}) => {
  const [state, setState] = useState({
    pending_date: null,
    pending_hour: null,
  });

  // Track original salary values to detect changes
  const [originalSalary, setOriginalSalary] = useState({
    salary_by: null,
    salary_value: null,
  });

  // Date picker for salary apply date
  const [salaryApplyDate, setSalaryApplyDate] = useState(null);

  const [dateGetSalary] = useState({
    placement: "top",
    text: "",
    body: "Là ngày chốt sổ lương và chuyển sang kỳ trả lương của tháng mới.",
  });

  const [dateJoin] = useState({
    placement: "top",
    text: "",
    body: 'Kỳ lương gần nhất sẽ được tính từ "Ngày tham gia" đến "Ngày thanh toán lương".',
  });

  const [salaryValue] = useState({
    placement: "top",
    text: "",
    body: "Nếu lương tính theo Giờ, công thức tính lương là: Mức lương Giờ * Số giờ làm việc * Số ngày tính lương.",
  });

  // Track the last synced employee ID to detect employee change
  const [lastSyncedId, setLastSyncedId] = useState(null);
  // Track if we're waiting for data to load
  const [waitingForData, setWaitingForData] = useState(false);

  useEffect(() => {
    // When ID changes, mark that we're waiting for data
    if (values.id && values.id !== lastSyncedId) {
      setWaitingForData(true);
    }
  }, [values.id]);

  useEffect(() => {
    // Only sync originalSalary when:
    // 1. We're waiting for data (ID just changed)
    // 2. Data has finished loading (isLoading = false)
    // 3. We have valid salary data
    if (
      waitingForData &&
      !isLoading &&
      values.id &&
      values.salary_value !== undefined
    ) {
      setState({
        ...state,
        pending_date: values.pending_date,
        pending_hour: values.pending_hour,
      });
      // Store original salary values when data is fully loaded
      const normalizedValue = values.salary_value
        ? String(values.salary_value).replace(/[,.]/g, "")
        : "";
      setOriginalSalary({
        salary_by: values.salary_by,
        salary_value: normalizedValue,
      });
      // Reset salary apply date to null (don't show by default)
      setSalaryApplyDate(null);
      // Mark this employee as synced
      setLastSyncedId(values.id);
      setWaitingForData(false);
    }
  }, [
    isLoading,
    values.id,
    values.salary_by,
    values.salary_value,
    waitingForData,
  ]);

  // Normalize salary value for comparison
  const normalizeValue = (val) => {
    if (!val) return "";
    return String(val).replace(/[,.]/g, "");
  };

  // Check if salary has changed (compare normalized values)
  // Only consider changed if we have synced this employee
  const hasSalaryChanged =
    lastSyncedId === values.id &&
    (values.salary_by !== originalSalary.salary_by ||
      normalizeValue(values.salary_value) !== originalSalary.salary_value);

  // Auto-set salaryApplyDate when salary changes
  useEffect(() => {
    if (hasSalaryChanged && !salaryApplyDate) {
      // Set default to today when salary first changes
      setSalaryApplyDate(moment());
    } else if (!hasSalaryChanged && salaryApplyDate) {
      // Reset when salary is reverted to original
      setSalaryApplyDate(null);
    }
  }, [hasSalaryChanged]);

  // Calculate totals
  const parseNumber = (val) => {
    if (!val) return 0;
    return parseInt(String(val).replace(/[,.]/g, ""), 10) || 0;
  };

  // Calculate base salary based on salary_by type
  const calculateBaseSalary = () => {
    const salaryValue = parseNumber(values.salary_value);
    const workingDays = parseFloat(values.current_day_working) || 0;
    const hoursPerDay = parseFloat(values.hour_working_on_day) || 8;

    switch (values.salary_by) {
      case "h": // Hourly: salary * hours_per_day * working_days
        return salaryValue * hoursPerDay * workingDays;
      case "d": // Daily: salary * working_days
        return salaryValue * workingDays;
      case "m": // Monthly: salary / 30 * working_days
      default:
        return Math.round((salaryValue / 30) * workingDays);
    }
  };

  const calculatedBaseSalary = calculateBaseSalary();

  // Tính tiền nghỉ phép dựa theo loại lương
  const calculateDayoffDeduction = () => {
    const salaryValue = parseNumber(values.salary_value);
    const hoursPerDay = parseFloat(values.hour_working_on_day) || 8;
    const dayoffHours = parseFloat(values.day_off_hour) || 0;

    switch (values.salary_by) {
      case "h": // Hourly: hourly_rate * leave_hours
        return Math.round(salaryValue * dayoffHours);
      case "d": // Daily: daily_rate / hours_per_day * leave_hours
        return Math.round((salaryValue / hoursPerDay) * dayoffHours);
      case "m": // Monthly: monthly_rate / 30 / hours_per_day * leave_hours
      default:
        return Math.round((salaryValue / 30 / hoursPerDay) * dayoffHours);
    }
  };

  const calculatedDayoffDeduction = calculateDayoffDeduction();

  // Tính tiền tăng ca dựa theo loại lương
  const calculateOvertimeIncome = () => {
    const salaryValue = parseNumber(values.salary_value);
    const hoursPerDay = parseFloat(values.hour_working_on_day) || 8;
    const overtimeHours = parseFloat(values.overtime_hour) || 0;

    switch (values.salary_by) {
      case "h": // Hourly: hourly_rate * overtime_hours
        return Math.round(salaryValue * overtimeHours);
      case "d": // Daily: daily_rate / hours_per_day * overtime_hours
        return Math.round((salaryValue / hoursPerDay) * overtimeHours);
      case "m": // Monthly: monthly_rate / 30 / hours_per_day * overtime_hours
      default:
        return Math.round((salaryValue / 30 / hoursPerDay) * overtimeHours);
    }
  };

  const calculatedOvertimeIncome = calculateOvertimeIncome();

  // Tổng phúc lợi: bao gồm cả tiền tăng ca đã tính
  const totalIncome =
    parseNumber(values.current_commission) +
    parseNumber(values.current_bonus) +
    calculatedOvertimeIncome;

  // Tổng khấu trừ: bao gồm cả tiền nghỉ phép đã tính
  const totalDeduction =
    parseNumber(values.current_advence) +
    parseNumber(values.current_fined) +
    calculatedDayoffDeduction;

  // Handle form submit with salary_apply_date
  const handleSubmit = (e) => {
    e.preventDefault();
    // Pass salary_apply_date to parent
    if (hasSalaryChanged && salaryApplyDate) {
      onChange(salaryApplyDate, "salary_apply_date");
    }
    onSubmit(
      e,
      salaryApplyDate ? moment(salaryApplyDate).format("YYYY-MM-DD") : null,
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      backdrop={true}
      className="modal-wide-95"
      style={{ maxWidth: "95vw", width: "95vw" }}
    >
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody className="pad-125rem">
          <PerfectScrollbar
            style={{ maxHeight: "70vh", paddingRight: "15px" }}
            options={{ suppressScrollX: true, wheelPropagation: false }}
          >
            <Row>
              {/* COLUMN 1: Thông tin cơ bản */}
              <Col xs={12} md={4}>
                <Card className="mb-4">
                  <CardBody>
                    <CardTitle tag="h5" className="mb-4">
                      <i className="simple-icon-user mr-2" />
                      Thông tin cơ bản
                    </CardTitle>

                    {/* Row 1: Tên + Vị trí */}
                    <Row>
                      <Col xs={12} md={6}>
                        <FormGroup className="has-float-label">
                          <Label for="name" className="text-muted">
                            <IntlMessages id="user-staff.name" />
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="text"
                            name="name"
                            id="name"
                            disabled={setting.viewonly && !setting.add}
                            value={values.name}
                            onChange={onChange}
                            className="text-capitalize"
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6}>
                        <FormGroup className="has-float-label">
                          <Label for="permission_name" className="text-muted">
                            <IntlMessages id="user-staff.permission_name" />
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Select
                            components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="permission_name"
                            value={GetPosition(values.permission_name)}
                            isDisabled={setting.viewonly && !setting.add}
                            placeholder="Chọn vị trí..."
                            options={PositionOptions()}
                            onChange={(e) => onChange(e, "permission_name")}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* Row 2: Email + SĐT */}
                    <Row>
                      <Col xs={12} md={6}>
                        <FormGroup className="has-float-label">
                          <Label for="email" className="text-muted">
                            <IntlMessages id="email" />
                          </Label>
                          <Input
                            type="email"
                            name="email"
                            id="email"
                            disabled={setting.viewonly && !setting.add}
                            value={values.email}
                            onChange={onChange}
                            className="text-lowercase"
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6}>
                        <FormGroup className="has-float-label">
                          <Label for="phone" className="text-muted">
                            <IntlMessages id="phone" />
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="text"
                            name="phone"
                            id="phone"
                            disabled={setting.viewonly && !setting.add}
                            value={values.phone}
                            onChange={onChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <FormGroup className="has-float-label">
                      <Label for="address" className="text-muted">
                        <IntlMessages id="address" />
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="address"
                        id="address"
                        disabled={setting.viewonly && !setting.add}
                        value={values.address}
                        onChange={onChange}
                        className="text-capitalize"
                      />
                    </FormGroup>

                    <DynamicForm
                      values={values.dynamic_form}
                      data={data_dynamic_form}
                      onChange={onChangeDynamicForm}
                      disabled={setting.viewonly && !setting.add}
                    />
                  </CardBody>
                </Card>

                {/* MOVED: Thời gian làm việc to Column 1 (below Basic Info) */}
                <Card className="mb-4">
                  <CardBody>
                    <CardTitle tag="h5" className="mb-4">
                      <i className="simple-icon-calendar mr-2" />
                      Thời gian làm việc
                    </CardTitle>

                    <Row>
                      <Col xs={12} md={6}>
                        <FormGroup className="has-float-label">
                          <Label for="date_join" className="text-muted">
                            <IntlMessages id="user-staff.date_join" />
                            <span style={{ color: "red" }}>*</span>
                            <TooltipItem item={dateJoin} id={1} />
                          </Label>
                          <DatePicker
                            name="date_join"
                            id="date_join"
                            onChange={(date) => onChange(date, "date_join")}
                            selected={moment(values.date_join)}
                            dateFormat="YYYY-MM-DD"
                            disabled={setting.viewonly && !setting.add}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6}>
                        <FormGroup className="has-float-label">
                          <Label for="date_get_salary" className="text-muted">
                            <IntlMessages id="user-staff.date_get_salary" />
                            <span style={{ color: "red" }}>*</span>
                            <TooltipItem item={dateGetSalary} id={2} />
                          </Label>
                          <Select
                            key={`date_get_salary_${values.id}`}
                            components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="date_get_salary"
                            value={GetDateGetSalary(values.date_get_salary)}
                            isDisabled={setting.viewonly && !setting.add}
                            placeholder={
                              <>
                                <IntlMessages id="select-one-time" />
                                <span style={{ color: "red" }}>*</span>
                              </>
                            }
                            options={DateGetSalary()}
                            onChange={(e) => onChange(e, "date_get_salary")}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} md={6}>
                        <FormGroup className="has-float-label">
                          <Label
                            for="hour_working_on_day"
                            className="text-muted"
                          >
                            <IntlMessages id="user-staff.hour_working_on_day" />
                          </Label>
                          <Select
                            key={`hour_working_on_day_${values.id}`}
                            components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="hour_working_on_day"
                            value={GetHourWorkingOnDay(
                              values.hour_working_on_day,
                            )}
                            isDisabled={setting.viewonly && !setting.add}
                            placeholder={
                              <>
                                <IntlMessages id="select-one-time" />
                                <span style={{ color: "red" }}>*</span>
                              </>
                            }
                            options={HourWorkingOnDay()}
                            onChange={(e) => onChange(e, "hour_working_on_day")}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6}>
                        <FormGroup className="has-float-label">
                          <Label for="salary_by" className="text-muted">
                            <IntlMessages id="user-staff.salary_by" />
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Select
                            key={`salary_by_${values.id}`}
                            components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="salary_by"
                            value={GetSalaryBy(values.salary_by)}
                            isDisabled={setting.viewonly && !setting.add}
                            placeholder={<IntlMessages id="select-one-time" />}
                            options={SalaryBy()}
                            onChange={(e) => onChange(e, "salary_by")}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} md={12}>
                        <FormGroup className="has-float-label">
                          <Label for="salary_value" className="text-muted">
                            <IntlMessages id="user-staff.salary_value" />{" "}
                            {`${GetSalaryBy(values.salary_by).label}`}
                            <span style={{ color: "red" }}>*</span>
                            <TooltipItem item={salaryValue} id={3} />
                          </Label>
                          <Input
                            type="text"
                            name="salary_value"
                            id="salary_value"
                            disabled={setting.viewonly && !setting.add}
                            value={AddCommaNumber(values.salary_value)}
                            onChange={onChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* Show date picker when salary changes */}
                    {hasSalaryChanged && (
                      <FormGroup className="has-float-label">
                        <Label className="text-muted">
                          <i className="simple-icon-calendar mr-1" />
                          Ngày bắt đầu áp dụng mức lương mới
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <DatePicker
                          name="salary_apply_date"
                          onChange={(date) => setSalaryApplyDate(date)}
                          selected={salaryApplyDate}
                          dateFormat="DD/MM/YYYY"
                          minDate={moment()}
                          className="form-control"
                          placeholderText="Chọn ngày áp dụng..."
                        />
                        <small className="text-info">
                          {salaryApplyDate ? (
                            <>
                              <i className="simple-icon-info mr-1" />
                              Trước ngày{" "}
                              <b>
                                {moment(salaryApplyDate).format("DD/MM/YYYY")}
                              </b>
                              , lương là{" "}
                              <b>
                                {AddCommaNumber(originalSalary.salary_value)}{" "}
                                {originalSalary.salary_by
                                  ? GetSalaryBy(originalSalary.salary_by).label
                                  : ""}
                              </b>
                              .
                              <br />
                              Từ ngày{" "}
                              <b>
                                {moment(salaryApplyDate).format("DD/MM/YYYY")}
                              </b>
                              , lương là{" "}
                              <b>
                                {AddCommaNumber(values.salary_value)}{" "}
                                {values.salary_by
                                  ? GetSalaryBy(values.salary_by).label
                                  : ""}
                              </b>
                              .
                            </>
                          ) : (
                            <>
                              <i className="simple-icon-info mr-1" />
                              Vui lòng chọn ngày áp dụng.
                            </>
                          )}
                        </small>
                      </FormGroup>
                    )}

                    <FormGroup>
                      <Label for="working_hours" className="text-muted">
                        <IntlMessages id="user-staff.working_hours" />
                      </Label>
                      <ShiftSelect
                        value={values.working_hours}
                        onChange={(workingHours) =>
                          onChangeWorkingHours(workingHours)
                        }
                        disabled={setting.viewonly && !setting.add}
                      />
                    </FormGroup>

                    <FormGroup className="has-float-label">
                      <Label for="status_working" className="text-muted">
                        <IntlMessages id="user-staff.status_working" />
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Select
                        key={`status_working_${values.id}`}
                        components={{ Input: CustomSelectInput }}
                        className="react-select"
                        classNamePrefix="react-select"
                        name="status_working"
                        value={GetStatusWorking(values.status_working)}
                        isDisabled={setting.viewonly && !setting.add}
                        placeholder={<IntlMessages id="select-one-time" />}
                        options={StatusWorking()}
                        onChange={(e) => onChange(e, "status_working")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>

              {/* COLUMN 2: Phúc lợi */}
              <Col xs={12} md={4}>
                {/* Card 1: Phúc lợi hiện tại (Editable) */}
                <Card className="mb-4">
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      className="d-flex justify-content-between align-items-center mb-4"
                    >
                      Phúc lợi và khấu trừ
                    </CardTitle>

                    {/* Thu nhập (+) */}
                    <div className="mb-3">
                      <small className="text-success font-weight-bold">
                        <i className="simple-icon-arrow-up mr-1" />
                        PHÚC LỢI
                      </small>
                    </div>
                    <Row>
                      <Col xs={4}>
                        <FormGroup className="has-float-label">
                          <Label>Hoa hồng</Label>
                          <Input
                            type="text"
                            name="current_commission"
                            value={AddCommaNumber(values.current_commission)}
                            onChange={onChange}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={4}>
                        <FormGroup className="has-float-label">
                          <Label>Thưởng</Label>
                          <Input
                            type="text"
                            name="current_bonus"
                            value={AddCommaNumber(values.current_bonus)}
                            onChange={onChange}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={4}>
                        <FormGroup className="has-float-label">
                          <Label>
                            Số giờ tăng ca ({values.overtime_hour || 0} giờ)
                          </Label>
                          <Input
                            type="text"
                            name="overtime_hour"
                            value={AddCommaNumber(calculatedOvertimeIncome)}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* Khấu trừ (-) */}
                    <div className="mb-3">
                      <small className="text-danger font-weight-bold">
                        <i className="simple-icon-arrow-down mr-1" />
                        KHẤU TRỪ
                      </small>
                    </div>
                    <Row>
                      <Col xs={4}>
                        <FormGroup className="has-float-label">
                          <Label>Phạt</Label>
                          <Input
                            type="text"
                            name="current_fined"
                            value={AddCommaNumber(values.current_fined)}
                            onChange={onChange}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={4}>
                        <FormGroup className="has-float-label">
                          <Label>Tạm ứng</Label>
                          <Input
                            type="text"
                            name="current_advence"
                            value={AddCommaNumber(values.current_advence)}
                            onChange={onChange}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={4}>
                        <FormGroup className="has-float-label">
                          <Label>
                            Số giờ nghỉ phép ({values.day_off_hour || 0} giờ)
                          </Label>
                          <Input
                            type="text"
                            name="day_off_hour"
                            value={AddCommaNumber(calculatedDayoffDeduction)}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* Tổng kết */}
                    <div className="border-top pt-3 mt-2">
                      <Row>
                        <Col xs={6}>
                          <small className="text-muted">Tổng phúc lợi:</small>
                          <div className="text-success font-weight-bold">
                            +{AddCommaNumber(totalIncome)}
                          </div>
                        </Col>
                        <Col xs={6} className="text-right">
                          <small className="text-muted">Tổng khấu trừ:</small>
                          <div className="text-danger font-weight-bold">
                            -{AddCommaNumber(totalDeduction)}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>

                {/* Card Lịch sử phúc lợi đã được bỏ vì không cần thiết */}
              </Col>

              {/* COLUMN 3: Thống kê lương - Clean Grouped Design */}
              <Col xs={12} md={4}>
                <Card className="mb-4">
                  <CardBody>
                    <CardTitle tag="h5" className="mb-4">
                      <i className="simple-icon-chart mr-2" />
                      Thống kê lương kỳ hiện tại
                    </CardTitle>
                    {/* TỔNG KẾT */}
                    <div className="salary-group">
                      <div
                        className="salary-group-header d-flex align-items-center p-2 rounded-top"
                        style={{
                          // backgroundColor: "#e2e3e5",
                          borderBottom: "2px solid #6c757d",
                        }}
                      >
                        <span style={{ fontSize: "1.2rem" }}>📊</span>
                        <span className="font-weight-bold ml-2">TỔNG KẾT</span>
                      </div>
                      <div
                        className="salary-group-body p-3"
                        style={{
                          // backgroundColor: "#fafafa",
                          // border: "1px solid #e2e3e5",
                          borderTop: "none",
                        }}
                      >
                        <div className="d-flex justify-content-between py-2">
                          <span className="text-muted">Ngày công:</span>
                          <span className="font-weight-bold">
                            {values.current_day_working || "0"} ngày
                          </span>
                        </div>
                        <div className="d-flex justify-content-between py-2">
                          <span className="text-muted">
                            Lương cơ bản
                            <small className="text-muted">
                              (
                              {values.salary_by === "h"
                                ? "Giờ"
                                : values.salary_by === "d"
                                  ? "Ngày"
                                  : "Tháng"}
                              )
                            </small>
                            :
                          </span>
                          <span className="font-weight-bold">
                            {AddCommaNumber(calculatedBaseSalary)}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between py-2">
                          <span className="text-success">+ Thu nhập:</span>
                          <span className="font-weight-bold text-success">
                            +{AddCommaNumber(totalIncome)}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between py-2">
                          <span className="text-danger">- Khấu trừ:</span>
                          <span className="font-weight-bold text-danger">
                            -{AddCommaNumber(totalDeduction)}
                          </span>
                        </div>

                        <hr style={{ borderTop: "2px solid #28a745" }} />

                        <div className="d-flex justify-content-between align-items-center py-2">
                          <span
                            className="font-weight-bold"
                            style={{ fontSize: "1.1rem" }}
                          >
                            💵 THỰC LÃNH:
                          </span>
                          <span
                            className="font-weight-bold text-success"
                            style={{ fontSize: "1.3rem" }}
                          >
                            {AddCommaNumber(
                              calculatedBaseSalary +
                                totalIncome -
                                totalDeduction,
                            )}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Tổng từ trước đến nay */}
                    <div
                      className="mt-4 p-3 text-center"
                      // style={{
                      //   backgroundColor: "#e8f5e9",
                      //   border: "1px solid #a5d6a7",
                      // }}
                    >
                      <div className="text-muted small">
                        Tổng lương từ trước đến nay
                      </div>
                      <div className="h4 mb-0 font-weight-bold text-success">
                        {AddCommaNumber(values.total_salary)} đ
                      </div>
                      <div className="text-muted small">
                        ({values.total_day_working || "0"} ngày công)
                      </div>
                    </div>

                    {/* Download Salary Button */}
                    {salaryDownloadData && salaryDownloadData.length > 0 && (
                      <div className="mt-3 text-center">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            color="primary"
                            size="sm"
                            className="w-100"
                          >
                            <i className="simple-icon-cloud-download mr-2" />
                            Tải bảng lương
                          </DropdownToggle>
                          <DropdownMenu className="w-100">
                            {salaryDownloadData.map((date, idx) => (
                              <DropdownItem
                                key={idx}
                                onClick={() => {
                                  onClickDownloadSalary({
                                    month: date.month,
                                    year: date.year,
                                  });
                                }}
                              >
                                <i className="simple-icon-doc mr-2" />
                                {`Lương tháng ${date.month}/${date.year}`}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </PerfectScrollbar>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Đóng
          </Button>{" "}
          <Button color="primary">
            <IntlMessages id="general.btn-update" />
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

const WarningMessage = (props) => {
  return (
    <Label className="warning-message">
      {`* ${props.text}${props.value}, tại ngày ${props.at}`}
    </Label>
  );
};

export default React.memo(ContentComponent);
